// 土耳其
export default {
    dialog: {
        msgShow: "Bildirim",
        buttonOk: 'Tamam',
        buttonCancel: 'İptal',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Kapat'
    },
    employeeNumber: 'Teknisyen kimliği',
    pleaseEnterEmployeeNumber: 'Teknisyen kimliği girin',
    password: 'Şifre',
    pleaseEnterPassword: 'Şifre girin',
    login: 'Giriş yap',
    required: 'Zorunlu',
    synchronize: 'Senkron',
    salesOrder: 'Servis raporu',
    pleaseEnterHome: 'Müşteri adı ve servis raporunu girin',
    searchFilter: 'Arama & Filtre',
    machineSpecifications: 'Model & Özellikler',
    processingStatus: 'Makine onarım durumu',
    processing: null,
    finish: null,
    waitCountermeasures: null,
    reset: 'Geri',
    submit: 'Gönderildi',
    muMachineInvestigation: 'Genel durum ve verimlilik',
    logout: 'Çıkış yap',
    searchDate: 'Arama tarihi',
    time: 'Arama zamanı',
    basicInformation: 'Müşteri bilgisi',
    addSalesOrder: null,
    save: 'Kaydet',
    date: 'Tarih',
    pleaseSelectDate: 'Tarih seçin',
    travelNumber: 'Servis raporu dosyası',
    pleaseEnterTravelNumber: 'Servis raporu numarası girin',
    customerCode: 'Müşteri kodu',
    pleaseEnterCustomerCode: 'Müşteri kodu girin',
    customerName: 'Müşteri adı',
    pleaseEnterCustomerName: 'Müşteri adı girin',
    country: 'Bölge',
    pleaseEnterCountry: 'Bölge girin',
    customerAddress: 'Müşteri adresi',
    pleaseEnterAddress: 'Müşteri adresi girin',
    customerContact: 'Müşteri yetkili kişi',
    pleaseEnterContact: 'Müşteri yetkili kişisi girin',
    salesRepresentative: 'Satış temsilcisi',
    pleaseEnterSalesRepresentative: 'Satış temsilcisi girin',
    hint: 'Bildirim',
    createDate: 'Kuruluş tarihi',
    salesOrderNumber: 'Servis raporu numarası',
    customerSatisfaction: 'Müşteri memnuniyeti',
    maintenancePersonnel: 'Teknisyen',
    maintenanceTime: 'Servis zamanı',
    customerConfirmation: 'Müşteri onayı',
    copy: 'Kopyala',
    delete: 'Sil',
    recordTime: null,
    machineNumber: 'Makina Seri No',
    copyToSalesOrder: 'Servis dosyasına ekle',
    copyTo: 'Kopyala',
    selectSalesOrderNumber: 'Servis raporu dosyası seçin',
    pleaseEnterSalesOrderNumber: 'Servis raporu numarası girin',
    latitudeAndLongitude: 'Enlem & Boylam',
    startMaintenance: 'Servise başlat',
    endMaintenance: 'Servisi bitir',
    newMachine: 'Kurulum raporu',
    maintenance: 'Makine onarımı',
    addMachineServiceOrder: null,
    selectType: 'Türü seçin',
    generalMaintenance: 'Makine onarımı',
    oilEducationTraining: 'OIL eğitimi',
    pleaseEnterMachineNumber: 'Makine numarası girin',
    manufacturingDate: 'Üretim tarihi',
    pleaseSelectManufacturingDate: 'Üretim tarihi seçin',
    maintenanceWarranty: 'Garanti durumu (1 yıl)',
    underWarranty: 'Garantili',
    warrantyExpired: 'Garantisiz',
    confirm: 'Tamam',
    cancel: 'İptal',
    addMaintenancePersonnel: 'Yeni teknisyen ekle',
    maintenanceTimeTotal: 'Toplam servis süresi',
    day: 'Gün',
    hour: 'Saat',
    enterFactory: 'Servisi başlat',
    pleaseSelectEnterFactory: 'Lütfen servisi başlatın',
    longitude: 'Boylam',
    // pleaseEnterLongitude: 'Enlem girin',
    latitude: 'Enlem',
    // pleaseEnterLatitude: 'Boylam girin',
    leaveFactory: 'Servisi bitir',
    pleaseSelectLeaveFactory: 'Lütfen servisi bitirin',
    duration: 'Servis süresi',
    pleaseEnter: 'Lütfen girin',
    selectTime: 'Lütfen girin servis süresi',
    selectSatisfaction: 'Müşteri memnuniyeti',
    verySatisfied: 'Çok memnun',
    satisfied: 'Memnun',
    ordinary: 'Yeterli',
    dissatisfied: 'Memnun değil',
    veryDissatisfied: 'Hiç memnun değil',
    opinionReply: 'Müşteri yorumu',
    takePhoto: 'Fotoğraf çek',
    uploadFile: 'Dosyayı yükle',
    audio: 'Ses dosyası',
    video: 'Video dosyası',
    electronicSignature: 'Müşteri imzası',
    signatureDate: 'İmza tarihi',
    clear: 'Sil',
    machineInformation: 'Makine verisi',
    machineFunction: 'Makine fonksiyon kontrolü',
    organizationArrangement: 'Çelik yapısı & Desen',
    spareParts: 'Makine parçaları',
    operationProcedure: 'Teknisyen Test Kayıtları',
    problemHandling: 'Problem tespiti',
    trainee: 'Eğitim alan',
    coursePlan: 'Eğitim planı',
    courseSchedule: 'Eğitim programı',
    inputVoltageAndCurrent: 'Voltajı ve akımı girin',
    lowSpeed: 'Düşük hız',
    highSpeed: 'Yüksek hız',
    accelerationDecelerationSlope: 'Hızlanma/Yavaşlama',
    acceleration: 'Hızlanma',
    deceleration: 'Yavaşlama',
    clothRoller: 'Alt çekim sistemi ayar',
    left: 'Sol',
    center: 'Orta',
    right: 'Sağ',
    yarnFeedingTeeth: 'Kasnak',
    saddleRingDistance: 'Hava Boşluğu',
    yarnNozzleNumber: 'Mekik Pozisyonu',
    height: 'Mekik&Kapak iğnesi arası mesafe',
    spacing: 'Mekik&Silindir iğnesi arası mesafe',
    warpYarnInfo: 'Ham kumaş',
    inch: 'İnç',
    cm: 'Cm',
    timeSequence: 'Zamanlama',
    needle: 'İğneler',
    yarnSpecification: 'İplik özellikleri',
    yarn: 'İplik',
    serialNumber: 'Diğer makinelerin seri numaraları',
    technician: 'Teknisyen',
    series: 'Kumaş parti no',
    fabricType: 'Kumaş tipi',
    productFeatures: 'Ürün özellikleri',
    inputVoltage: 'Voltaj girin',
    inputCurrent: 'Akım girin',
    electronicWindingTensionUpper: 'Elektronik çekim sistemi gerginliği (Yüksek)',
    electronicWindingTensionLower: 'Elektronik çekim sistemi gerginliği (Alçak)',
    mechanicalType: 'Mekanik çekim sistemi dişli konumu',
    lowerNeedleDistanceToSeatRing: 'Platin tablası hava boşluğu',
    upperNeedleDistanceToSeatRing: 'Kapak kovanı hava boşluğu',
    upperNeedleDistanceToLowerNeedleNozzle: 'Kapak ve silindir arasındaki mesafe',
    selectorNeedleRingDistanceToTakeUpPlate: 'Silindir kovanı ve seçici arasındaki hava boşluğu',
    seatRingDistanceToTakeUpPlate: 'Silindir kovanı hava boşluğu',
    machineSpeed: 'Rpm',
    inverterFrequency: 'Hz',
    yarnCount: 'İlmek Sayısı',
    gramsPerSquareMeter: 'gr/m2',
    yardsPerPound: 'gr/yd',
    customerYarnWidth: 'En',
    customerSpecifiedYarnLength: 'İplik Uzunluğu Ayarı',
    newCustomerPackageTiming: 'Platin zamanlaması',
    doubleSidedCuttingTiming: 'Kapak çeliği zamanlaması',
    nozzleTiming: 'Mekik zamanlaması',
    yarnCode: 'İplik kodu',
    yarnType: 'İplik özelliği',
    color: 'İplik rengi',
    yarnSize: 'İplik numarası',
    fiberCount: 'Filament sayısı',
    innerFiber: 'İç Hav',
    outerFiber: 'Dış Hav',
    flatness: 'Pürüzsüzlük',
    roundness: 'Düzgünsüzlük',
    windPressure: 'Hava basıncı',
    appearance: 'Dış Görüntü',
    machineLevel: 'Makine kasa dengesi',
    trident: 'Kapak kovan dengesi',
    highLegWinder: 'Yüksek ayak alt çekim sistemi',
    fabricSlitting: 'Açık en alt çekim sistemi',
    inverterCurrent: 'İnvertör akımı',
    machineFunctionFrame: 'Memminger & Çember & Çardak',
    inchStart: 'Yavaş, Başlat ve Durdur Fonksiyonu',
    firstSecondSpeed: 'Hız, lamba & pervane Ayar Fonksiyonu',
    firstSecondSpeed2: 'Hız ayarı fonksiyonu',
    controllerOtherFunctions: 'Ekranın diğer fonksiyonları',
    electricalBoxSignals: 'Sinyal & Kontak',
    fanDustRemovalAction: 'Pervane çalışması',
    oilSprayerAction: 'Yağdanlık çalışması',
    airBlowerSystemAction: 'Hava basıncı ve çalışması',
    windingAction: 'Alt çekim sistemi çalışması',
    machineControllerOperationTutorial: 'Kontrol ekranı eğitimi',
    machineOperationTutorial: 'Makine çalıştırma eğitimi',
    other: 'Diğer',
    descriptionAndAttachment: 'Referans görseli',
    upperNeedleArrangement: 'Kapak iğne dizilimi',
    upperKnifeArrangement: 'Kapak bıçak dizilimi',
    lowerNeedleArrangement: 'Silindir iğne dizilimi',
    lowerNeedleArrangementShort: 'Silindir iğne dizilimi',
    lowerKnifeArrangement: 'Silindir bıçak dizilimi',
    lowerKnifeArrangementShort: 'Silindir bıçak dizilimi',
    upperNeedlePlate: 'Kapak Kovanı',
    lowerNeedleCylinder: 'Silindir Kovanı',
    blank: 'Hava Boşluğu',
    blockRule: 'Sabitleme',
    retractionBaseline: 'Platin- iğne arasındaki mesafe',
    upperPlateNeedleWithdrawalKnob: 'Kapak Mayı',
    upperPlateNeedleWithdrawalDepth: 'Kapak Kovanı May Ayarı',
    upperPlateHalfNeedleHeight: 'Kapak Örgü ve Fank Çeliği İlmek Uzunluğu Ayarı',
    upperPlateFlatNeedleHeight: 'Kapak İptal Çeliği İlmek Uzunluğu Ayarı',
    lowerCylinderFlatNeedleHeight: 'Silindir İptal Çeliği İlmek Uzunluğu Ayarı',
    lowerCylinderFlatNeedleDepth: 'Silindir Kovanı May Ayarı',
    lowerCylinderNeedleWithdrawalKnob: 'Silindir Mayı',
    yarnTypeCode: 'İplik kodu',
    yarnTypeTensionN: 'İplik tansiyonu (N)',
    cmPer100Needles: 'İplik uzunluğu (100 iğnede)',
    feedYarnLengthPerRevolution: 'İplik uzunluğu (1 ilmekte)',
    aluminumPlateYarnFeedingDepthCm: 'Kasnak İç Çap Ölçüsü (cm)',
    yarnFeedingAluminumPlateScale: 'Kasnak Ölçüsü',
    newCustomerPackage: 'Platin',
    upperPlate: 'Kapak',
    lowerCylinder: 'Silindir',
    yarnShort: 'İplik',
    pleaseEnterProductName: 'Parça açıklaması girin',
    pleaseEnterProductNumber: 'Parça numarası girin',
    quantity: 'Adet',
    damage: 'Kırık',
    missing: 'Eksik',
    wrong: 'Yanlış',
    pleaseEnterTitle: 'Başlık girin',
    pleaseEnterContent: 'İçeriği girin',
    addQuestionItem: 'Soru ekleyin',
    questionProcessingRecord: 'Servis çözüm kaydı',
    pleaseEnterQuestionDescription: 'Sorun açıklaması girin',
    traineeAndClient: 'Eğitilen / Müşteri',
    trainer: 'Eğiten',
    drawingFunction: 'CAD çizimi',
    upperMachineProgram: 'Makine programı',
    UnravelingFunction: 'Kumaş analizi',
    courseName: 'Eğitim adı',
    pleaseEnterCourseName: 'Eğitim adı girin',
    imageName: 'Desen adı',
    pleaseEnterImageName: 'Desen adı girin',
    confirmItem: 'Onayla',
    undone: 'Eksik',
    pleaseEnterInquire: 'Müşteri adı girin, MU numarasını girin',
    machineUtilizationSurvey: 'Müşteri iş durumu & Makina kullanım oranı',
    customerID: 'Müşteri kimliği',
    pleaseEnterCustomerID: 'Müşteri kimliği girin',
    pleaseSelect: 'Lütfen seçin',
    pleaseEnterSkill: 'Lütfen beceriyi girin',
    pleaseEnterBuyer: 'Lüften alıcıyı girin',
    pleaseEnterRemark: 'Lütfen açıklamayı girin',
    source: 'Kaynak',
    selfInput: '自行輸入',
    textileEquipment: 'Örgü makinesi',
    textileMachineBrand: 'Örgü makinesi markası',
    textileMachineType: 'Örgü makinesi modeli',
    notSelected: 'Seçilmedi',
    select: 'Seçildi',
    brand: 'Marka',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'Lütfen ayar içeriğini girin',
    // alert
    editNotSave: 'Değişiklikler kaydedilmeden çıkmak istediğinizden emin misiniz?',
    deleteConfirm: 'Silmek istediğinizden emin misiniz?',
    confirmClearSignature: 'İmzayla ilgili verileri kaldırmak istediğinizden emin misiniz?',
    confirmWriteData: 'Veri yazmayı onaylıyor musunuz?',
    confirmCopyToSalesOrder: 'Verileri bu servis raporuna kopyalamak istediğinizden emin misiniz?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'Başarıyla silindi.',
    clearSuccess: 'Başarıyla temizlendi.',
    copySuccess: 'Kopyalama tamamlandı.',
    selectWorker: 'Lütfen Teknisyen Seçin',
    selectProblem: 'Lütfen Problemli Parça Seçin',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'Tarih seçin',
    yarnTensionN: 'İplik tansiyonu (N)',
    category: 'Tür',
    kind: 'Model',
    // pleaseSelectType: 'Türü seçin',
    dateInOutError: 'Servisin Bitiş Tarihi Her Zaman Servisin Başlangıç ​​Tarihine Eşit Veya Ondan Sonra Olmalıdır.',
    yarnFeedingTeethOrDisc: 'Kasnak',
    changed: 'Değişenler',
    pleaseSelectSparePartsStatus: 'Lütfen Yedek Parça Durumu Seçin',
    pleaseEnterDuration: null,

    // API語系
    saveComplete: 'Kayıt başarılı',
    needOnline: 'Need Online.',
    addComplete: 'Ekleme başarılı',
    reportCreator: 'Raporu Hazırlayan',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: '同步異常',
    synchronizeSuccess: 'Başarılı bir şekilde senkronize edildi.',
    downloadFail: '下載異常',
    downloadSuccess: 'Başarılı bir şekilde indirildi.',
    synchronizeSelect: 'Sekronize Seçimi',
    onlySynchronizeOffData: 'Çevrimiçi Verileri İndirme',
    synchronizeData: null,
    synchronizeImage: 'Görüntüyü senkronize et',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'Çevrimdışı Veriyi İndir',
    downloadOfflineImage: 'Çevrimdışı Görseli İndir',
    synchronizing: 'Senkronize ediliyor, lütfen bekleyin. Uygulama ekranını kapatmayın.',
    downloading: 'İndiriliyor, lütfen bekleyin. Uygulama ekranını kapatmayın.',
    confirmDownload: 'İndirmeyi Onaylıyor Musunuz? ',
    confirmSynchronization: 'Senkronizasyonu onaylıyor musun?',
    overwriteOffline : 'İndirme işlemi mevcut çevrimdışı verilerin üzerine yazılacaktır.',
    synchronizationOnline: 'Senkronizasyon çevrimiçi ilgili verileri senkronize edecektir.',
    uploadFail: '上傳異常',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'Yaratılma tarihine göre sırala',
    sortByType: 'Türe göre sırala',
    reportDownload: 'rapor',
    selectServiceReport: 'Servis Raporunu Seç',
    enterServiceReportOrMachine: 'Servis raporu no. veya makine no. girin',
    selectAll: 'Hepsini seç',

    downloadHint:null
}
